import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import ActivationPage from "./activate";
import { RegistrationPage } from "./registration";
import { LoginPage } from "./login";
import PasswordResetPage from "./password/reset";
import PasswordResetConfirmPage from "./password/confirm";

import {
  AzureSSORedirectPage,
  AzureSSOFailurePage,
  AzureSSORedirectCompletePage,
} from "./azure";

function AccountsRouter() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      {/* Login */}
      <Route exact path={`${path}/login`} component={LoginPage} />

      {/* Registration */}
      <Route exact path={`${path}/register`} component={RegistrationPage} />

      {/* Email activation */}
      <Route
        exact
        path={`${path}/activate/:activationKey`}
        component={ActivationPage}
      />

      {/* Password reset pages */}
      <Route
        exact
        path={`${path}/password/reset`}
        component={PasswordResetPage}
      />
      <Route
        exact
        path={`${path}/reset/:uid/:token`}
        component={PasswordResetConfirmPage}
      />
      <Route
        exact
        path={`${path}/password/reset/:uid/:token`}
        component={PasswordResetConfirmPage}
      />

      {/* Password reset pages */}
      <Route
        exact
        path={`${path}/login/sso/azure`}
        component={AzureSSORedirectPage}
      />
      <Route
        exact
        path={`${path}/login/sso/fail`}
        component={AzureSSOFailurePage}
      />
      <Route
        exact
        path={`${path}/login/sso/azure/success`}
        component={AzureSSORedirectCompletePage}
      />
    </Switch>
  );
}

export default AccountsRouter;
